import React, { useState, useEffect, FC } from "react";
import { Table, Button, Input, Checkbox, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { usePurchasePoDetailsModel, IMaterialDetailModel } from "./purchasePoDetailsModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { YhPageHeader } from "@/components/YhPageHeader";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { IMaterialBase, IMaterialDetail, IMaterialSearchFields, materialService } from "../../../../base/material/materialService"
import useNavModel, { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";
enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}

export const AddGoodsModal: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language,setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();

    const { addModalVisible: visible, workDataSource,initPgCfg, workPgCfg, addDataSource, searchWorkData, setWorkDataSource, resetWorkloadData, setSearchWorkData, setAddDataSource, transformsToPoDetailList, workloadData, setAddModalVisible, } = usePurchasePoDetailsModel();
    useEffect(() => {
        workloadData()
    }, [])
    // : ColumnsType<IMaterialDetailModel>
    const column = (optype: number) => [
        {
            // title: '商品编号',
            title: Locale['Material Code'],
            width: 100,
            dataIndex: 'code',
            align: "left",
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 100,
            dataIndex: 'nameEn',     
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>, 
        }, {
            // title: '商品名称',
            title: Locale['Material Name'],
            width: 100,
            dataIndex: 'name',
            align: "left",
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '数量',
            title: Locale['Qty'],
            width: 120,
            dataIndex: 'num',
            align: "left",
            editable: true,
        }, {
            // title: '单价',
            title: Locale['Unit Price'],
            width: 120,
            dataIndex: 'purchasePrice',
            align: "left",
            editable: true,
        }, {
            // title: '金额',
            title: Locale['Amount'],
            width: 120,
            dataIndex: 'amount',
            align: "left",            
        // }, {
        //     // title: '替换编号',
        //     title: Locale['Manufacturer Code'],
        //     width: 180,
        //     dataIndex: 'replaceCode',
        //     align: "left",
        //     render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        // }, {
        //     // title: '产地',
        //     title: Locale['Production Place'],
        //     width: 120,
        //     dataIndex: 'madeFrom',
        //     align: "left",
        // }, {
        //     // title: '规格',
        //     title: Locale['Spec'],
        //     width: 150,
        //     dataIndex: 'model',
        //     align: "left",
        //     render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '库存',
            title: Locale['Inventory'],
            width: 120,
            dataIndex: 'inventoryNum',
            align: "left",
        }, {
            // title: '单位',
            title: Locale['Unit'],
            width: 140,
            dataIndex: 'unitCode',
            align: "left",
            render: (text: any) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string
                } else {
                    return ""
                }
            }

        }, {
            // title: '仓库',
            title: Locale['Warehouse'],
            width: 120,
            dataIndex: 'warehouseName',
            align: "left",
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '货位',
            title: Locale['Shelf'],
            width: 120,
            dataIndex: 'shelfCode',
            align: "left",
        }, {
            // title: '操作',
            title: Locale['Operation'],
            width: 120,
            fixed: "right",
            align: "center",
            render: (text: string, record: IMaterialDetailModel) => optype == OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    // txt="添加"
                    txt={Locale['Add']}
                    click={() => add(record)}
                    disabled={!!addDataSource.find(item => item.id === record.id)}
                />
            ) : (
                    <YhBut
                        type="delete"
                        // txt="删除"
                        txt={Locale['Delete']}
                        click={() => remove(record)}
                    />
                )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType == OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })
    const notHandleSave = (row: IMaterialDetailModel) => {
        let newRow = {
            ...row,
            amount: (Number(row.num) * Number(row.purchasePrice)).toFixed(2)
        }
        const index = workDataSource.findIndex((item) => row.id === item.id);
        const item = workDataSource[index];
        console.log(newRow, index)
        workDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkDataSource([...workDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let newRow = {
            ...row,
            amount: (Number(row.num) * Number(row.purchasePrice)).toFixed(2)
        }
        const index = addDataSource.findIndex((item) => row.id === item.id);
        const item = addDataSource[index];
        console.log(newRow, index)
        addDataSource.splice(index, 1, { ...item, ...newRow });
        setAddDataSource([...addDataSource])
    }
    const add = async (record: IMaterialDetailModel) => {
        console.log(record)
        setAddDataSource(origin => [...origin, record])
    }
    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataSource.filter(item => item.id != record.id)
        setAddDataSource(filterAddDataSource)
    }
    const onOK = async () => {
        transformsToPoDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setAddModalVisible(false);
        setAddDataSource([])

    };
    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.code}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, code: e.target.value }) }}
            // placeholder="商品编码"
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder={Locale['Material Code']}
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.name}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, name: e.target.value }) }}
            onPressEnter={() => workloadData(initPgCfg)}
            // placeholder="商品名称"
            placeholder={Locale['Material Name']}
        />
        <Button onClick={() => workloadData()} style={{ margin: "0px 5px 0px 10px" }} shape="round">{Locale["Search"]}</Button>
        <Button onClick={() => resetWorkloadData()} shape="round">{Locale["Reset"]}</Button>
    </div>
    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        // title="采购单-选择配件"
        title={Locale["Purchase Doc -Select Materials"]}
        width={1000}
        bodyHeight={750}
        showFooter={true}
    >
        <YhBox title={Locale["List of materials to be selected"]} rightChildren={rightChildren} style={{ marginBottom: "15px" }}>
            <Table
                // size="small"
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id}
                columns={newSelectColumns(OPT_TYPE.ADD) as ColumnsType<IMaterialDetailModel>}
                dataSource={workDataSource}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                pagination={{
                    ...workPgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workloadData({ pageNum, pageSize });
                    }
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title={Locale["List of selected materials"]}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id}
                columns={newSelectColumns(OPT_TYPE.REMOVE) as ColumnsType<IMaterialDetailModel>}
                dataSource={[...addDataSource]}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}